/*
 *   Copyright (c) 2026 vlinder Labs Private Limited
 *   All rights reserved.
 */

/**
 * Handles automatic form submission for payment gateway responses returning
 * either htmlCode or formAction with formFields.
 *
 * @param paymentRes The gateway response object containing htmlCode, formAction, formFields, etc.
 * @returns boolean True if form submission was initiated, false otherwise.
 */
export function handleFormPaymentResponse(paymentRes: any): boolean {
  if (!paymentRes) return false;

  // 1. If htmlCode snippet is returned
  if (paymentRes?.htmlCode) {
    try {
      const div = document.createElement("div");
      div.style.display = "none";
      div.innerHTML = paymentRes.htmlCode;
      document.body.appendChild(div);

      const form =
        div.querySelector("form") ||
        (document.getElementById("paymentForm") as HTMLFormElement);

      if (form) {
        sessionStorage.setItem("went_to_payment", "true");
        localStorage.setItem("went_to_payment", "true");
        form.submit();
        return true;
      }
    } catch (err) {
      console.error("[formPayment.util] Error submitting htmlCode form:", err);
    }
  }

  // 2. If formAction (and optional formFields) is returned
  if (paymentRes?.formAction) {
    try {
      const form = document.createElement("form");
      form.method = "POST";
      form.action = paymentRes.formAction;
      form.style.display = "none";

      let fields = paymentRes?.formFields || {};
      if (typeof fields === "string") {
        try {
          fields = JSON.parse(fields);
        } catch (e) {
          console.warn("[formPayment.util] Could not parse formFields JSON string", e);
        }
      }

      if (Array.isArray(fields)) {
        fields.forEach((field: any) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = field?.name || field?.key || "";
          input.value = field?.value ?? field ?? "";
          form.appendChild(input);
        });
      } else if (typeof fields === "object" && fields !== null) {
        Object.keys(fields).forEach((key) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = key;
          const val = fields[key];
          input.value = typeof val === "object" ? JSON.stringify(val) : String(val);
          form.appendChild(input);
        });
      }

      document.body.appendChild(form);
      sessionStorage.setItem("went_to_payment", "true");
      localStorage.setItem("went_to_payment", "true");
      form.submit();
      return true;
    } catch (err) {
      console.error("[formPayment.util] Error submitting formAction form:", err);
    }
  }

  return false;
}
